import { NotificationsListSide } from 'civil-status/view-models/notifications-list-side';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<NotificationsListSide, keyof NotificationsListSide>[] = [
  {
    id: 'sourceEvent',
    label: 'Evento Sorgente',
  },
  {
    id: 'municipalityDestination',
    label: 'Comune destinatario',
  },
  {
    id: 'registerSource',
    label: 'Registro sorgente',
  },
  {
    id: 'register',
    label: 'Registro di destinazione',
  },
  {
    id: 'ambito',
    label: 'Ambito',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'formationDate',
    label: 'Formazione',
  },
  {
    id: 'operator',
    label: 'Operatore',
  },
];
